import { EDeviceTypes } from '~/src/dash/utils/devices';
import { IntEnumToArray } from '~/src/dash/utils/utils_enum';

// Sub/Super models
// tslint:disable-next-line:class-name
export interface ISuperSiteConfigForType_EndpointParam {
  ParamType: ESuperSiteTargetingObjectEndpointParamsType; // Custom_4, ...
  Value: string;
}

export interface ISuperSiteTargetingObject {
  SuperSiteTargetingObjectType: ESuperSiteTargetingObjectType;
  CustomConfigOnlyString: string;
  CustomConfigEndpointParam: ISuperSiteConfigForType_EndpointParam;
  CustomConfigDeviceEnvironment: number[]; // see src/dash/utils/device-environments.ts:8
  CustomConfigDeviceType: EDeviceTypes[];
}

export enum ESuperSiteTargetingObjectType {
  ENDPOINT_PARAM = 0,
  WSEAT = 1,
  DEALID = 2,
  APP_BUNDLE = 3,
  DEVICE_ENVIRONMENT = 4,
  DEVICE_TYPE = 5,
}
export const ESuperSiteTargetingObjectTypeValues = IntEnumToArray(ESuperSiteTargetingObjectType);

export enum ESuperSiteTargetingObjectEndpointParamsType {
  CUSTOM_4 = 0,
  CUSTOM_5 = 1,
  CUSTOM_6 = 2,
  CUSTOM_7 = 3,
  CUSTOM_8 = 4,
}
export const ESuperSiteTargetingObjectEndpointParamsTypeValues = IntEnumToArray(
  ESuperSiteTargetingObjectEndpointParamsType,
);

export enum ESuperSiteTargetingLogicOperator {
  AND = 0,
  OR = 1,
}

export interface IUserSync {
  key: string;
  text: string;
}

export const bypassDedupOptions: IUserSync[] = [
  { key: 'BypassMediafileDedup', text: 'Mediafile' },
  { key: 'BypassAdomainDedup', text: 'Adomain' },
  { key: 'BypassIABCatDedup', text: 'IAB Category' },
];

export interface IEndpointRequestScore {
  CountEndpointRequests: number;
  CountRequestHasAppBundle: number;
  CountRequestHasAppBundleOrSitePage: number;
  CountRequestHasAppName: number;
  CountRequestHasAppStoreUrl: number;
  CountRequestHasContentCategory: number;
  CountRequestHasContentChannel: number;
  CountRequestHasContentGenre: number;
  CountRequestHasContentID: number;
  CountRequestHasContentNetwork: number;
  CountRequestHasContentRating: number;
  CountRequestHasContentTitle: number;
  CountRequestHasIP: number;
  CountRequestHasMaxAdDuration: number;
  CountRequestHasMinAdDuration: number;
  CountRequestHasPodDuration: number;
  CountRequestHasPodDurationOrSlotCount: number;
  CountRequestHasSitePage: number;
  CountRequestHasSlotCount: number;
  CountRequestHasUserAgent: number;
}

export interface IChannelPerformanceSortByOptions {
  TotalRevenue: number;
  TotalRequests: number;
  TotalImpressions: number;
}

export interface IChannelCronSummary {
  Last24HrImpressions: string;
  PastWeekImpressions: string;
  Last24HrAverageCPM: string;
  PastWeekAverageCPM: string;
  Last24HrRevenue: string;
  PastWeekRevenue: string;
  Last24HrEndpointRequests: string;
  PastWeekEndpointRequests: string;
}

export interface ISmallSite {
  ID: number;
  Name: string;
  Active: number;
  DeletedAt?: string;
  DefaultWeight?: number;
  UUID?: string;
  BidFloor?: number;
  SuperSiteID?: number;
}

export function IsSmallSiteActive(s: ISmallSite): boolean {
  return s.Active === 2;
}

// for api v1
// warning: in v1, name is spelled "name"
export function transformSmallSiteWrapper(fromObj: any): ISmallSite {
  return {
    ID: +fromObj.ID,
    Name: fromObj.name,
    Active: +fromObj.Active,
    DefaultWeight: fromObj.DefaultWeight,
  };
}
